import {
  setUserBookPref,
  deleteUserBookPref,
} from "../../api/features/preferences/actions";
import { getUserBookPref } from "../../api/features/preferences/selectors";
import { UserBookPreference } from "../../api/features/preferences/utils";
import { useGenericPreference } from "./useGenericPreference";

const api = {
  get: getUserBookPref,
  set: setUserBookPref,
  del: deleteUserBookPref,
};

export default function useUserBookPreference(key: UserBookPreference) {
  return useGenericPreference<UserBookPreference>(api, key);
}
